var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBiomeWeightApeironScale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.5H4C2.89543 2.5 2 3.39543 2 4.5V20.5C2 21.6046 2.89543 22.5 4 22.5H20C21.1046 22.5 22 21.6046 22 20.5V4.5C22 3.39543 21.1046 2.5 20 2.5Z",
    stroke: "#BEC7D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5L13 8.5",
    stroke: "#BEC7D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.50013C11.0793 5.49442 10.1665 5.67159 9.31461 6.02135C8.46275 6.37111 7.68881 6.88651 7.03766 7.53766C6.38651 8.18881 5.87111 8.96275 5.52135 9.81461C5.17159 10.6665 4.99442 11.5793 5.00013 12.5001H19.0001C19.0058 11.5793 18.8287 10.6665 18.4789 9.81461C18.1292 8.96275 17.6138 8.18881 16.9626 7.53766C16.3115 6.88651 15.5375 6.37111 14.6857 6.02135C13.8338 5.67159 12.921 5.49442 12.0001 5.50013Z",
    stroke: "#BEC7D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBiomeWeightApeironScale);
export default __webpack_public_path__ + "static/media/ic-biome-weight-apeiron-scale.a05cb3c1036897073ded66b991415702.svg";
export { ForwardRef as ReactComponent };